import { render, staticRenderFns } from "./BindAuthorityProduction.vue?vue&type=template&id=14ad4a09&scoped=true"
import script from "./BindAuthorityProduction.vue?vue&type=script&lang=js"
export * from "./BindAuthorityProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ad4a09",
  null
  
)

export default component.exports